import { Icon, IconProps } from "@chakra-ui/react";

function DeliveryNoteIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity="0.12"
        d="M2.66669 5.7C2.66669 4.5799 2.66669 4.01984 2.88467 3.59202C3.07642 3.21569 3.38238 2.90973 3.75871 2.71799C4.18653 2.5 4.74658 2.5 5.86669 2.5H10.1334C11.2535 2.5 11.8135 2.5 12.2413 2.71799C12.6177 2.90973 12.9236 3.21569 13.1154 3.59202C13.3334 4.01984 13.3334 4.5799 13.3334 5.7V14.5L11.5 13.1667L9.83335 14.5L8.00002 13.1667L6.16669 14.5L4.50002 13.1667L2.66669 14.5V5.7Z"
        fill="currentColor"
      />
      <path
        d="M2.66669 5.7C2.66669 4.5799 2.66669 4.01984 2.88467 3.59202C3.07642 3.21569 3.38238 2.90973 3.75871 2.71799C4.18653 2.5 4.74658 2.5 5.86669 2.5H10.1334C11.2535 2.5 11.8135 2.5 12.2413 2.71799C12.6177 2.90973 12.9236 3.21569 13.1154 3.59202C13.3334 4.01984 13.3334 4.5799 13.3334 5.7V14.5L11.5 13.1667L9.83335 14.5L8.00002 13.1667L6.16669 14.5L4.50002 13.1667L2.66669 14.5V5.7Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}

export default DeliveryNoteIcon;
